import {Component, ViewEncapsulation, ViewChild, OnDestroy, AfterViewInit, ElementRef} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription  } from 'rxjs';
import { map } from "rxjs/operators";
import {SolrService, SharedDataService} from '@signature-it/ngx-catalogue/services';
import {TreeViewComponent} from './tree-view/tree-view.component';
import { FiltersComponent } from '@signature-it/ngx-catalogue/components/filters';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { SeoService_Generic } from '@signature-it/ngx-generic/services';
import {Group} from '@signature-it/ngx-catalogue/models';

declare let _: any;

const CUSTOM_ELEMENT_TAG_NAME = 'NGX-CATALOGUE-SIDEBAR';

@Component({
    selector: 'catalogue-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SidebarComponent_Catalogue implements AfterViewInit, OnDestroy {
    filterFacet: any;
    currentGroupId: any;
    userLinks: object = {};
    filtersData: any = [];
    prevQueryParams: object;
    kw: string;
    isPromo: boolean;
    isCampaign: boolean;
    currentGroupSubscription: Subscription;
    queryParamsSubscription: Subscription;
    totalItems:number;
    isLeafGroup = false;
    showSortOptions = false;
    group: Group;

    @ViewChild('treeView') protected treeView: TreeViewComponent;
    @ViewChild('filtersComponent', {static: true}) filtersComponent: FiltersComponent;

    constructor(
        public sharedData: SharedDataService,
        public solrService: SolrService,
        public router: Router,
        public route: ActivatedRoute,
        public location: Location,
        public seoSvc: SeoService_Generic,
        public elRef: ElementRef) {
    }

    ngAfterViewInit () {
        const self = this;
		this.currentGroupSubscription = this.sharedData.getCurrentGroup.subscribe((group: Group) => {
            if (group) {
                this.group = group;
                this.showSortOptions = this.group.isleaf && GenericConfig.catalogueSort ? GenericConfig.catalogueSort.location === 'filters' : false;
                this.currentGroupId = group.id;
                this.sharedData.groupId = group.id;
                this.prevQueryParams = null;
                this.isLeafGroup = group.isleaf;
                this.queryParamsSubscription = self.route.queryParams
                    .pipe(map(params => self.loadQueryParams(params)))
                    .subscribe((params) => {
                        if(params) {
                            self.sharedData.getQueryParams.next(params);
                            self.sharedData.getQueryParams.next(null);
                            if(self.treeView) {
                                self.treeView.showRelevantGroups(this.group, this.kw, this.filtersData);
                            }
                        }
                    });
            }
        });
        if (this.elRef.nativeElement.tagName === CUSTOM_ELEMENT_TAG_NAME) {
            this.sharedData.ngxSidebarCmp.next(this);
        }
        this.subscribeFilterFacet();
    }

    ngOnDestroy() {
        this.currentGroupSubscription.unsubscribe();
    }

    loadQueryParams(params) {
        if(_.isEqual(this.prevQueryParams, params)) return false;
        this.filtersData = [];
        this.kw =  '';
        let page = null;
        let itemsPerPage;
        let sort = '';
        let parsedUrl = this.router.parseUrl(this.router.url);
        let extraQryString;
        if(!_.isEmpty(parsedUrl.queryParams)) {
            const parsedKw = new DOMParser().parseFromString(parsedUrl.queryParams.kw, 'text/html');
            this.kw = parsedUrl.queryParams.kw ? parsedKw.body.textContent || '' : undefined;
            this.showSortOptions = !!this.kw && GenericConfig.catalogueSort && GenericConfig.catalogueSort.location === 'filters' ;
            page = parsedUrl.queryParams.page;
            itemsPerPage = parsedUrl.queryParams.itemsPerPage;
            sort = parsedUrl.queryParams.sort;
            extraQryString = parsedUrl.queryParams.extraQryString || '';
            this.isPromo = parsedUrl.queryParams.promo == '1'? true: false;
            this.isCampaign = parsedUrl.queryParams.campaign? true: false;
            delete parsedUrl.queryParams.kw;
            delete parsedUrl.queryParams.extraQryString;
            delete parsedUrl.queryParams.page;
            delete parsedUrl.queryParams.itemsPerPage;
            delete parsedUrl.queryParams.promo;
            delete parsedUrl.queryParams.campaign;
            delete parsedUrl.queryParams.sort;
            let skipQueryParamKeys = GenericConfig.skipQueryParamKeys || [];
            // https://jira.il1.signature-it.com/browse/TFN-577
            skipQueryParamKeys.push('__v'); // this param added only to update the route on this.router.navigate in main component
            skipQueryParamKeys.push('lang');
            this.filtersData = Object.keys(parsedUrl.queryParams)
                .filter(key => !skipQueryParamKeys.includes(key))
                .reduce((obj, key) => {
                    obj[key] = parsedUrl.queryParams[key];
                    return obj;
                }, {});
        }
        if (this.kw) {
            this.seoSvc.setNoIndexNoFollow();
        } else {
            this.seoSvc.setIndexFollow();
        }
        this.sharedData.filtersData.next(this.filtersData);
        let obj = {filters: this.filtersData, kw: this.kw, page, itemsPerPage, sort, extraQryString};
        this.prevQueryParams = params;
        return obj;
    }

    onLoadGroup(currentGroup) {
        this.sharedData.loadGroup.next(currentGroup);
    }

    subscribeFilterFacet() {
        this.sharedData.setFilterFacet.subscribe(filterFacet => {
            if (filterFacet) {
                this.filterFacet = filterFacet;
            }
        });
    }

    // Check filters from url, not filters to be rendered
    hasNoFilters() {
        return _.isEmpty(this.filtersData) && (_.isUndefined(this.kw) || this.kw == '') && !this.isPromo && !this.isCampaign;
    }

    resetAll(event) {
        event.stopPropagation();
        this.sharedData.clickedFilter.next({fields: {}});
    }
}
